import { render, staticRenderFns } from "./MergeTab.vue?vue&type=template&id=6ae5a174&scoped=true"
import script from "./MergeTab.vue?vue&type=script&lang=js"
export * from "./MergeTab.vue?vue&type=script&lang=js"
import style0 from "./MergeTab.vue?vue&type=style&index=0&id=6ae5a174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5a174",
  null
  
)

export default component.exports